var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"no-padding",attrs:{"fill-height":"","fluid":""}},[_c('div',{staticClass:"blue-background"}),_c('login-card')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }